var $034c7393857c8db0$exports = {};
$034c7393857c8db0$exports = {
    "close": `Fechar`,
    "notifications": `Notifica\xe7\xf5es`
};


export {$034c7393857c8db0$exports as default};
//# sourceMappingURL=pt-PT.mjs.map
